console.log(`API INIT STARTING`);

import Atom from "shlibs/dist/Atom";
import StackAtom from "shlibs/dist/StackAtom";
import {initMemoList} from "./memo-list";
// import {RecoilRoot} from "recoil";
// import React from "react";
import {openPopup} from "../js-app/util/state-util";
import {initAPI} from "./api";

export type MemoItem = {wpID:number, bookingID:number};

//Define state
export const as_memory = new StackAtom<MemoItem>('memo_content',[],{});
export const as_memoPopupOpen = new Atom<boolean>('memo_open',false);
export const as_memoPopupReady = new Atom<boolean>('memo_ready',false);
export const as_memoPopupMessage = new Atom<string>('memo_message','');

export const as_requestPopupOpen = new Atom<boolean>('popup_open',false);
export const as_requestPopupReady = new Atom<boolean>('popup_ready',false);
export const as_popupsMutuallyExclusive = new Atom<boolean>('popup_excluded',true);

//make popups mutually exclusive
as_requestPopupOpen.subscribe((nv)=>{ as_popupsMutuallyExclusive.get() && nv && as_memoPopupOpen.set(false); })
as_memoPopupOpen.subscribe((nv)=>{ as_popupsMutuallyExclusive.get() && nv && as_requestPopupOpen.set(false); })



as_requestPopupOpen.subscribe((newVal)=>{
    const body = document.querySelector("body,html");
	if(newVal) body.classList.add('menu-open');
	else       body.classList.remove('menu-open');
})
as_memoPopupOpen.subscribe((newVal)=>{
    const body = document.querySelector("body,html");
	if(newVal) body.classList.add('menu-open');
	else       body.classList.remove('menu-open');
})

var reqBtn = document.querySelectorAll(".neo-request-btn, .open-request-popup");
reqBtn?.forEach((el)=>{
  el.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      setRequestPopupVisibility(true);
    
  });
})

export function setRequestPopupVisibility(vis:boolean){
    
    if(!vis){
        as_requestPopupOpen.set(false);
    }else{
        if(as_requestPopupReady.get()){
            as_requestPopupOpen.set(true);
        }else{
            import('../js-app/RequestPopup').then((mo)=>{
                var c = (v)=> {
                    openPopup(true);
                    as_requestPopupReady.removeSubscriber(c);
                };
                as_requestPopupReady.subscribe(c);
            });
        }
    }
}


/**
 * Will toggle the memo list popup if it is already, loaded, otherwise first load it then display
 * @param e A clickevent that will stop Propagation, optional
 */
export function toggleMemoList(e?:any){
	if(e){
		e.preventDefault();
		e.stopPropagation();
		!e.stopImmediatePropagation || e.stopImmediatePropagation();
	}
    
    var newVis = !as_memoPopupReady.get() ? true : !as_memoPopupOpen.get();
	setMemoPopupVisibility(newVis);
}

export function setMemoPopupVisibility(vis:boolean){
    if(!vis){
        as_memoPopupOpen.set(false);
    }else{
        //on click check if the memoList is already loaded and if not load it.
        if(!as_memoPopupReady.get()){
            import('../js-memo/MemoList').then((mo)=>{
                var c = (v)=> {
                    as_memoPopupOpen.set(true);
                    as_memoPopupReady.removeSubscriber(c);
                };
                as_memoPopupReady.subscribe(c);
            });
        }else{
            as_memoPopupOpen.set(vis);
        }
    }
}

initMemoList();

var ready = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
}
ready(() => {
	
	//Init the Global CSS
	var globalCSS = window['NeoData']?.data?.formData?.generalCss;
	const style = document.createElement('style');
	style.textContent = `${globalCSS}`;
	document.head.appendChild(style);
	
	//First load the button
	import('../js-memo/elements/MemoFloatingButton').then(()=>{
		//add clcik handler to loaded button
        document.querySelectorAll(".neo-memo-btn,#neo-memo-btn")?.forEach((btn)=>{
            btn.addEventListener('click',toggleMemoList)
        })
	});
	import('../js-menu/MemoMenuButton');
});

initAPI();
console.log(`API INIT STARTED`);